module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toasts",
    attrs: {
      "role": "status",
      "aria-live": "polite",
      "aria-atomic": "false"
    }
  }, [(_vm.toasts.length > 0) ? [_c('transition-group', _vm._l((_vm.toasts), function(toast, index) {
    return _c('div', {
      key: toast.id
    }, [_c('toast', {
      attrs: {
        "index": index,
        "toast": toast,
        "arrayLength": _vm.toasts.length
      },
      on: {
        "remove": _vm.remove,
        "removeNow": _vm.removeNow
      }
    })], 1)
  }), 0)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a6644a04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast/Manager.vue
// module id = 2079
// module chunks = 1